import { useState } from "react";
import { toast } from "sonner";
import { Field, Card, SaveButton, FileLabel, GhostButton, inputCls, areaCls } from "../ui";
import { adminUpload, adminFetch } from "../adminApi";

export default function AdminAbout({ content, reload }) {
  const [draft, setDraft] = useState(() => JSON.parse(JSON.stringify(content.about || {})));
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [uploading, setUploading] = useState(false);

  const update = (key, value) => setDraft((d) => ({ ...d, [key]: value }));

  const uploadPhoto = async (file) => {
    setUploading(true);
    try {
      const r = await adminUpload(file);
      update("photo_url", r.url);
      toast.success("Foto hochgeladen – jetzt unten auf Speichern klicken.");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setUploading(false);
    }
  };

  const save = async () => {
    setSaving(true);
    try {
      await adminFetch("/admin/content/about", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(draft),
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
      await reload();
      toast.success("Über-mich-Bereich gespeichert – live auf der Website.");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <p className="text-sm text-zinc-400 leading-relaxed">
        Dein persönlicher Bereich auf der Startseite. Schreibe in der Ich-Form – ehrlich und
        bodenständig wirkt besser als jede Werbesprache.
      </p>

      <Card title="Über mich / Vertrauen">
        <Field label="Überschrift">
          <input data-testid="admin-about-heading" className={inputCls} value={draft.heading || ""} onChange={(e) => update("heading", e.target.value)} maxLength={120} />
        </Field>
        <Field label="Vorstellungstext">
          <textarea data-testid="admin-about-text" className={`${areaCls} min-h-[160px]`} value={draft.text || ""} onChange={(e) => update("text", e.target.value)} maxLength={3000} />
        </Field>

        <div>
          <p className="mb-1.5 font-mono text-[11px] uppercase tracking-wider text-zinc-400">Foto von dir / deiner Arbeit</p>
          {draft.photo_url ? (
            <img src={draft.photo_url} alt="Über mich" className="h-40 w-full max-w-[240px] rounded-xl object-cover border border-zinc-800" />
          ) : (
            <p className="text-xs text-zinc-400 mb-2">Noch kein Foto hinterlegt – auf der Website erscheint ein sauberer Platzhalter.</p>
          )}
          <FileLabel testid="admin-about-photo" onFile={uploadPhoto}>
            {uploading ? "Wird hochgeladen …" : "Foto hochladen / ersetzen"}
          </FileLabel>
        </div>

        <Field label="Kurze Fakten (eine pro Zeile, optional)">
          <textarea
            className={areaCls}
            value={(draft.facts || []).join("\n")}
            onChange={(e) => update("facts", e.target.value.split("\n").filter((x) => x.trim() !== ""))}
            placeholder={"z. B. Mobiles Equipment\nGeprüfte Pflegemittel"}
          />
        </Field>

        <Field label="Arbeitsweise (optional)">
          <textarea className={areaCls} value={draft.workflow || ""} onChange={(e) => update("workflow", e.target.value)} maxLength={2000} placeholder="Wie gehst du bei einer Aufbereitung konkret vor?" />
        </Field>
      </Card>

      <div className="sticky bottom-4 flex items-center gap-3 rounded-2xl border border-[#27272A] bg-[#0C0C0E]/95 p-4 backdrop-blur">
        <SaveButton onClick={save} saving={saving} saved={saved} testid="admin-save-about" />
        <GhostButton onClick={() => setDraft(JSON.parse(JSON.stringify(content.about || {})))} testid="admin-reset-about">
          Verwerfen
        </GhostButton>
      </div>
    </div>
  );
}
